import Tooltip from "@mui/material/Tooltip";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { AccountCircle } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const ParticipantsTooltip = ({ leader, others = [], showIcon = true ,onClick = () => {} }) => {
 
  const {t} = useTranslation();

  const othersCount = others.length;

  const tooltipContent = (
    <Box sx={{ p: 0.5 }}>
      {others.map((user, index) => (
        <Typography
          key={index}
          variant="body2"
          sx={{ px: 1, py: 0.5, whiteSpace: "nowrap" }}
        >
          {user.firstName} {user.lastName}
        </Typography>
      ))}
    </Box>
  );

  return (
    <Tooltip
      onClick={onClick}
      title={othersCount > 0 ? tooltipContent : ""}
      placement="bottom-start"
      arrow
      disableHoverListener={othersCount === 0}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          color: "text.secondary",
          cursor: othersCount > 0 ? "pointer" : "default",
        }}
      >
        {showIcon && <AccountCircle style={{ fontSize: "0.8rem" }} />}

        <Typography variant="body2">
          {leader?.firstName|| t("global:participantsTooltipNoData")} {leader?.lastName}
        </Typography>

        {(othersCount > 0 && Boolean(leader)) && (
          <Typography variant="body2">+{othersCount}</Typography>
        )}
      </Box>
    </Tooltip>
  );
};

export default ParticipantsTooltip;
